import { Enum } from 'app-core/helpers';

export const BILLING_CYCLES = new Enum([
    {id: 0, name: 'Monthly'},
    {id: 1, name: 'Quarterly'},
    {id: 2, name: 'Annual'},
    {id: 3, name: 'SixMonthly'},
]);

export const BILLING_PAYMENT_TYPE = new Enum([
    {id: 0, name: 'Automatic', icon: 'fas fa-retweet'},
    {id: 1, name: 'Manual', icon: 'fas fa-user-alt'},
    {id: 2, name: 'Invoice', icon: 'fas fa-file-invoice'},
]);

export const BILLING_DETAIL_STATUS = new Enum([
    {id: 0, css: 'unpaid', name: 'On hold'},
    {id: 1, css: 'active', name: 'Active'},
    {id: 2, css: 'canceled', name: 'Canceled'},
    {id: 3, css: 'initial', name: 'Pending activation'},
    {id: 4, css: 'trial', name: 'Trial'},
    {id: 5, css: 'trial', name: 'Trial'}
]);

export const EXTERNAL_SERVICES_CATEGORIES = new Enum([
    {id: 0, name: 'None'},
    {id: 1, name: 'Weather'},
    {id: 2, name: 'Sport'},
    {id: 3, name: 'System'},
    {id: 4, name: 'VastMacros'},
]);

export const DAP_CATEGORY_TYPES = new Enum([
    { id: 0, name: 'Podcast', icon: 'fas fa-microphone-alt', components: { budget: true, display: true }, hasPodcasts: true, multiple: true, disableStreamingsFilters: true },
    { id: 1, name: 'Display', icon: 'fas fa-ad', components: { budget: true, display: true, geofencing: true, remarketing: true }, multiple: true },
    { id: 2, name: 'Airtime', icon: 'fas fa-broadcast-tower', components: { airtime: true }, recurrent: false },
    { id: 3, name: 'ConnectedTv', icon: 'fas fa-network-wired', components: { budget: true, display: true }, multiple: true },
    { id: 4, name: 'Sem', icon: 'fas fa-search', components: { budget: true }, multiple: true },
    { id: 5, name: 'Television', icon: 'fas fa-tv', components: { budget: true, display: true }, multiple: true },
    { id: 6, name: 'Annual', icon: 'fas fa-compass', components: { budget: true, display: true }, multiple: true },
    { id: 7, name: 'Audio', icon: 'fas fa-volume-up', components: { budget: true, display: true }, multiple: true },
    { id: 8, name: 'Video', icon: 'fas fa-video', components: { budget: true, display: true }, multiple: true },
]);

export const CAMPAIGN_TYPES = new Enum([
    {id: 0, name: 'Proposal'},
    {id: 1, name: 'Campaign'},    
]);

export const RATING_METHODS = new Enum([
    {id: 0, name: 'Per day'},
    {id: 1, name: 'Per week'},
    {id: 2, name: 'Per month'},
    {id: 3, name: 'Per year'},  
    {id: 4, name: 'CPM'},
    {id: 5, name: 'Per click'},
    {id: 6, name: 'Per spot'},
]);

export const AD_RUN_TYPES = new Enum([
    {id: 0, name: 'Pre roll'},
    {id: 1, name: 'Mid roll'},
    {id: 2, name: 'Post roll'}
])

export const PRODUCT_ACTIVATION_STATUSES = new Enum([
    {id: 0, name: 'Payment required' },
    {id: 1, name: 'Initializing' },
    {id: 2, name: 'In progress' },
    {id: 3, name: 'Activated' },
    {id: 4, name: 'Error' },
])

export const AUDIO_PIXEL_TYPES = new Enum([
    {id: 0, name: 'Impression' },
    {id: 1, name: 'Start' },
    {id: 2, name: 'First Quartile' },
    {id: 3, name: 'Mid Point' },
    {id: 4, name: 'Third Quartile' },
    {id: 5, name: 'Complete' },
])

export const CREATIVE_SCRIPT_SOURCE_TYPES = new Enum([
    {id: 0, name: 'Script' },
    {id: 1, name: 'HTML' },
    {id: 2, name: 'iFrame' }
])

export const ALPHABETS = new Enum([
    { id: 'ipa', name: 'IPA (International Phonetic Alphabet)', link: 'https://en.wikipedia.org/wiki/International_Phonetic_Alphabet' },
    { id: 'sapi', name: 'SAPI (Speech service phonetic alphabet)', link: 'https://docs.microsoft.com/en-us/azure/cognitive-services/speech-service/speech-ssml-phonetic-sets?tabs=en-US' },
    { id: 'ups', name: 'UPS (Universal Phone Set)', link: 'https://documentation.help/Microsoft-Speech-Platform-SDK-11/17509a49-cae7-41f5-b61d-07beaae872ea.htm' },
])


export const REPEAT_TYPES = new Enum([
	{ id: 'HOURLY', name: 'Hourly', intervalCaption: 'hour(s)' },
	{ id: 'DAILY', name: 'Daily', intervalCaption: 'day(s)' },
	{ id: 'WEEKLY', name: 'Weekly', intervalCaption: 'week(s)' },
	{ id: 'MONTHLY', name: 'Monthly', intervalCaption: 'month(s)' },
	{ id: 'YEARLY', name: 'Yearly', intervalCaption: 'year(s)' },
])

export const WEEK_DAYS = new Enum([
	{ id: 'MO', name: 'Mon' },
	{ id: 'TU', name: 'Tue' },
	{ id: 'WE', name: 'Wed' },
	{ id: 'TH', name: 'Thu' },
	{ id: 'FR', name: 'Fri' },
	{ id: 'SA', name: 'Sat' },
	{ id: 'SU', name: 'Sun' },
]);

export const MONTHS = new Enum([
	{ id: 1, name: 'January' },
	{ id: 2, name: 'February' },
	{ id: 3, name: 'March' },
	{ id: 4, name: 'April' },
	{ id: 5, name: 'May' },
	{ id: 6, name: 'June' },
	{ id: 7, name: 'July' },
	{ id: 8, name: 'August' },
	{ id: 9, name: 'September' },
	{ id: 10, name: 'October' },
	{ id: 11, name: 'November' },
	{ id: 12, name: 'December' }
]);

export const SERVICE_STATUSES = new Enum([
	{ id: 0, name: 'Alive' },
	{ id: 1, name: 'Unknown' },
	{ id: 2, name: 'Error' }
]);

export const DELEGATION_PERMISSIONS = new Enum([
	{ id: 0, name: 'Manage creatives' }
]);

export const CREATIVE_PUBLISH_SCHEDULE_STATUSES = new Enum([
    { id: 0, name: 'None' },
    { id: 1, name: 'Planned' },
	{ id: 2, name: 'InProgress' },
	{ id: 3, name: 'Stopped' },
	{ id: 4, name: 'Finished' },
    { id: 5, name: 'Error' },
]);

export const PERSISTENT_SCHEDULE_RUN_STATUS = new Enum([
    { id: 0, name: 'Stopped' },
    { id: 1, name: 'Started' },
    { id: 2, name: 'Terminated' },
]);

export const PERSISTENT_SCHEDULE_JOB_TYPE = new Enum([
    { id: 0, name: 'NewsML Ftp Import' }
]);

export const PERSISTENT_SCHEDULE_POST_IMPORT_ACTION = new Enum([
    { id: 0, name: 'Rename processed files' },
    { id: 1, name: 'Delete processed files' }
]);

export const PERSISTENT_SCHEDULE_JOB_STATUS = new Enum([
    { id: 0, name: 'Scheduled' },
    { id: 1, name: 'Enqueued' },
    { id: 2, name: 'Processing' },
    { id: 3, name: 'Failed' },
    { id: 4, name: 'Succeeded' },
    { id: 99999, name: 'Uknnown' },
]);

export const LEXICON_TYPES = new Enum([
    { id: 0, name: 'Lexicon' },
    { id: 1, name: 'Custom TN' }
])

export const OUTPUT_STATUS = new Enum([
    { id: 0, name: 'Active' },
    { id: 1, name: 'In development' },
    { id: 2, name: 'Disabled' },
])

export const SSML_STYLIZER_TAG_TYPES = new Enum([
    { id: 0, name: 'Sentence' },
    { id: 1, name: 'Word' },
    { id: 2, name: 'Story' },
])

export const AI_MUSIC_STATUS = new Enum([
    { id: 0, name: 'None' },
    { id: 1, name: 'Lyrics generating' },
    { id: 2, name: 'Lyrics done' },
    { id: 3, name: 'Music generating' },
    { id: 4, name: 'Music done' },
    { id: 5, name: 'Error' },
])

export const AI_MUSIC_VOCALS = new Enum([
    { id: 0, name: 'None' },
    { id: 1, name: 'Male' },
    { id: 2, name: 'Female' },
    { id: 3, name: 'Duet' },
    { id: 4, name: 'Instrumental' }
])

export const SPEECH_PROVIDER_TYPES = new Enum([
    { id: 0, name: 'Azure Speech' },
    { id: 1, name: 'OpenAI' },
    { id: 2, name: 'ElevenLabs' },
    { id: 3, name: 'Google' },
    { id: 4, name: 'Wellsaid' },
    { id: 5, name: 'PlayHt' },
    { id: 6, name: 'Amazon' },
])

export const VOICE_TYPES = new Enum([
    { id: 0, name: 'Tts', code: 'Tts' },
    { id: 1, name: 'Azure PublicNeural', code: 'Azure_PublicNeural' },
    { id: 2, name: 'Azure PrivateNeural', code: 'Azure_PrivateNeural' },
    { id: 3, name: 'Azure Human', code: 'Azure_Human' },
    { id: 4, name: 'Azure HumanTts', code: 'Azure_HumanTts' },
    { id: 5, name: 'Azure OpenAi', code: 'Azure_OpenAi' },
    { id: 6, name: 'ElevenLabs Premade', code: 'ElevenLabs_Premade' },
    { id: 7, name: 'ElevenLabs Professional', code: 'ElevenLabs_Professional' },
    { id: 8, name: 'Google Unknown', code: 'Google_Unknown' },
    { id: 9, name: 'Google Neural2', code: 'Google_Neural2' },
    { id: 10, name: 'Google Studio', code: 'Google_Studio' },
    { id: 11, name: 'Google Standard', code: 'Google_Standard' },
    { id: 12, name: 'Google WaveNet', code: 'Google_WaveNet' },
    { id: 13, name: 'Google Journey', code: 'Google_Journey' },
    { id: 14, name: 'Google Casual', code: 'Google_Casual' },
    { id: 15, name: 'Google News', code: 'Google_News' },
    { id: 16, name: 'Google Polyglot', code: 'Google_Polyglot' },
    { id: 17, name: 'Well Said', code: 'WellSaid' },
    { id: 18, name: 'PlayHt Stock', code: 'PlayHt_Stock' },
    { id: 19, name: 'PlayHt Cloned', code: 'PlayHt_Cloned' },
    { id: 20, name: 'Amazon', code: 'Amazon' },
    { id: 21, name: 'Azure Neural HD', code: 'Azure_NeuralHD'},
    { id: 22, name: 'Google Chirp', code: 'Google_Chirp'},
])

export const VOICE_CREATOR_PUBLISHING_STATUS = new Enum([
    { id: 0, name: 'None' },
    { id: 1, name: 'Processing' },
    { id: 2, name: 'Completed' },
    { id: 3, name: 'Failed' },
])